import { Injectable } from '@angular/core';

function _window(): any {
  return window;
}

// RESOURCE: https://juristr.com/blog/2016/09/ng2-get-window-ref/
@Injectable({ providedIn: 'root' })
export class WindowService {

  static getNativeWindow(): any {
    return _window();
  }

  static scrollToTop() {
    // NOTE: window.scrollTo is generally more reliable than document.body.scrollTop;
    // plus, using document.body.scrollTop seemed to disrupt the behavior of the GemsStickyComponent
    // RESOURCE: https://stackoverflow.com/questions/39601026/angular-2-scroll-to-top-on-route-change
    // [Patterson, John - 2017.07.12.15.48]
    _window().scrollTo(0, 0);
  }

  static getLocationHost() {
    return _window().location.hostname;
  }
}
